import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { BankData, BankService } from '../../services/bank.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-update-bank',
  templateUrl: './update-bank.component.html',
  styleUrls: ['./update-bank.component.css']
})
export class UpdateBankComponent implements OnInit {

  clabeError: boolean;

  bankForm: FormGroup;

  bankId: string;
  bank: any;
  subsciptionBank: Subscription;

  bankSelect: any[];
  utilitySelect: any[];
  currencySelect: any[];

  clabeCharsCurrent: number = 0;
  clabeCharsDesired: number = 18;

  constructor(
    private bankService: BankService,
    private bankData: BankData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.bankId = this.activatedRoute.snapshot.paramMap.get('id');

    this.bankSelect = bankData.bankSelect;
    this.utilitySelect = bankData.utilitySelect;
    this.currencySelect = Object.keys(bankData.currencies).map(value => ({
        value: value,
        ...bankData.currencies[value]
    }) );
  }

  ngOnInit() {
    this.createForm();
    this.subsciptionBank = this.bankService.getBank(this.bankId).subscribe( ({isIncome, isOutcome, ...data}) => {
      this.subsciptionBank.unsubscribe();
      if(!isOutcome) data.utility = 'income';
      if(!isIncome) data.utility = 'outcome';
      this.bank = {
        utility: 'both',
        ...data
      };
      this.clabeCharsCurrent = this.bank.CLABE.length;
      
      this.bankForm.patchValue(this.bank);
    });
  }

  ngOnDestroy() {
  }

  createForm() {
    this.bankForm = this.fb.group({
      bankName: ['', Validators.required],
      accountNumber: ['', Validators.required],
      CLABE: ['', [Validators.maxLength(18), Validators.minLength(18)]],
      utility: ['', Validators.required],
      currency: [this.currencySelect[0].value, Validators.required]
    });
  }

  onInputClabe(CLABE: string){
    this.clabeCharsCurrent = CLABE.length;
    this.clabeError = !(CLABE.length == 18);
  }

  async onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let {utility, ...valueBank} = value;
    let bank = {
      isIncome: true,
      isOutcome: true,
      ...valueBank
    };
    
    if(utility == 'income') bank.isOutcome = false;
    if(utility == 'outcome') bank.isIncome = false;
    
    await this.bankService.updateBank(this.bankId, value);
    this.bankService.windowReplace('read');
  }

}
